
import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from '@/components/ui/card';
import { Lock, Shield, RefreshCw, Zap } from 'lucide-react';

const TrustSection = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4 }}
      className="max-w-3xl mx-auto mt-12 space-y-6"
    >
      {/* Main Trust Features */}
      <Card className="bg-gradient-to-r from-gray-50 to-white shadow-sm border border-gray-200/60">
        <CardContent className="p-6 sm:p-8">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                <Lock className="h-4 w-4 text-green-600" />
              </div>
              <div>
                <h3 className="font-medium text-gray-900 text-sm">Bank-Level Security</h3>
                <p className="text-xs text-gray-600">SSL encrypted & PCI compliant</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                <Shield className="h-4 w-4 text-blue-600" />
              </div>
              <div>
                <h3 className="font-medium text-gray-900 text-sm">Trusted Infrastructure</h3>
                <p className="text-xs text-gray-600">Same security as Zoom & Slack</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                <RefreshCw className="h-4 w-4 text-orange-600" />
              </div>
              <div>
                <h3 className="font-medium text-gray-900 text-sm">No-Risk Trial</h3>
                <p className="text-xs text-gray-600">Cancel anytime, no fees</p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Stripe Badge */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
        className="text-center"
      >
        <div className="inline-flex items-center space-x-3 px-6 py-3 bg-white border border-gray-200 rounded-full shadow-sm">
          <div className="flex items-center space-x-2">
            <Zap className="h-4 w-4 text-indigo-600" />
            <span className="text-sm font-medium text-gray-700">Payments powered by</span>
          </div>
          <div className="text-lg font-bold text-indigo-900 tracking-tight">Stripe</div>
        </div>
        <p className="text-xs text-gray-500 mt-3 max-w-md mx-auto">
          Join millions of businesses worldwide who trust Stripe to handle billions in transactions securely
        </p>
      </motion.div>
    </motion.div>
  );
};

export default TrustSection;
